import { FC } from 'react';

import { WerklijnContextMenuDetails } from '@/components/contextMenu/mwdContextMenu/types';
import DefectRow from '@/components/defectRow/DefectRow';
import useDefectGereedMeldenDialog from '@/components/dialogs/defecten/gereedMelden/useDefectGereedMeldenDialog';
import { Checkbox } from '@/components/UI/Checkbox/Checkbox';
import MwdDialog from '@/components/UI/Dialog/Dialog';
import FieldGroup from '@/components/UI/Fields/FieldGroup';
import { Label } from '@/components/UI/Label/Label';
import Notification from '@/components/UI/Notification/Notification';
import useFormHtml from '@/hooks/useFormHtml';
import useDefecten from '@/state/selectors/useDefecten';
import { MaakDefectNietInzetBaarFormType } from '@/types/Defecten';

import styles from '@/components/UI/Dialog/Dialog.module.css';

type AanmakenNietInzetbaarVanafDialogProps = {
  showDialog: boolean;
  handleOpenChange: (p: boolean) => void;
  details: WerklijnContextMenuDetails;
};

const DefectGereedMeldenDialog: FC<AanmakenNietInzetbaarVanafDialogProps> = ({
  showDialog,
  handleOpenChange,
  details,
}) => {
  const { handleCheckboxChange, resetDialog, onSubmit, error } = useDefectGereedMeldenDialog(handleOpenChange);
  const { formSubmitCallback } = useFormHtml<MaakDefectNietInzetBaarFormType>(onSubmit);

  const { defectenView } = useDefecten(
    [details.eenheidnummer],
    ['DEFECT_NIET_INZETBAAR', 'BEPERKING_IN_TREINDIENST', 'GEEN_BEPERKINGEN'],
    {
      geefAlleenNietGereedGemeldeDecten: true,
      sorteerOpTijd: true,
      geefAlleenDefectenTerugTotEindeBijsturingsPeriode: false,
    },
  );

  return (
    <MwdDialog
      title='Gereedmelden defect(en)'
      hasError={error}
      className={styles.gereedMeldenDialogStyle}
      showDialog={showDialog}
      hasCloseInHeader={true}
      handleOpenChange={handleOpenChange}
      data-testid={`contextMenu-${details?.treinnummer}-${details.eenheidnummer}`}
    >
      <Notification style={{ height: '96px', marginBottom: '14px' }}>
        Let op: Meld hier alleen een defect gereed als dat niet lukt in Maximo. Dit moet later alsnog in Maximo
        gebeuren.
      </Notification>
      <form onSubmit={formSubmitCallback}>
        <div>
          <Label>Eenheid</Label>
          <div
            style={{ color: 'var(--tractie-color-content-default)' }}
          >{`${details.eenheidnummer} (${details.materieelSoortEersteInzet})`}</div>

          <div style={{ color: 'var(--tractie-color-content-default)' }} />
          <div
            style={{
              height: '2px',
              marginBottom: '8px',
              marginTop: '8px',
              width: '100%',
              background: 'var(--tractie-color-border-subtle)',
            }}
          />
        </div>
        <FieldGroup.Col boxProps={{ width: '100%' }} required fieldId='InzetbaarheidLabel' label='Defecten'>
          <div style={{ maxHeight: '220px', overflowY: 'auto' }}>
            {defectenView?.map((defect) => (
              <div
                style={{
                  display: 'flex',
                  borderBottom: `1px solid 'var(--tractie-color-border-subtle)`,
                }}
                key={defect.id}
              >
                <Checkbox
                  data-testid={`defect-checkbox-${defect.werkorderId}`}
                  onChange={(isChecked) => handleCheckboxChange(defect.id, isChecked)}
                />
                <DefectRow disabledHoverAndBorder defect={defect} positie='enkelvoudig' />
              </div>
            ))}
          </div>
        </FieldGroup.Col>
        <MwdDialog.Footer submitCaption='Meld defect gereed' cancelCallback={() => resetDialog(true)} />
      </form>
    </MwdDialog>
  );
};
export default DefectGereedMeldenDialog;
